import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const createService = (params) => {
  return Api(endPoints.createService, params, requestType.POST);
};

export const deleteService = (id) => {
  return Api(`${endPoints.deleteService}/${id}`, null, requestType.DELETE);
};

export const fetchAllServices = (id) => {
  return Api(`${endPoints.getAllServices}/${id}`, null, requestType.GET);
};

// New Flow Work

export const getAllServices = (ids) => {
  return Api(
    `${endPoints.getAllServices}?branchId=${ids}`,
    null,
    requestType.GET
  );
};

export const getServiceDetails = (id) => {
  return Api(`${endPoints.getServiceDetails}/${id}`, null, requestType.GET);
};

export const updateAllService = (id, params) => {
  return Api(`${endPoints.updateAllService}/${id}`, params, requestType.PUT);
};

